<div class="eone-capacity-expansion-card-plugin" hive-root>
    <div class="eone-capacity-expansion-card-plugin__headline">
        Projected to exceed reserve in {{ renderInfo().daysToExceedCurrentReserve }} days
    </div>
    @if (renderInfo().sparklineOptions) {
        <div class="eone-capacity-expansion-card-plugin__sparkline-container">
            <div #sparklineContainer class="eone-capacity-expansion-card-plugin__sparkline-chart"></div>
        </div>
    }
    <div class="eone-capacity-expansion-card-plugin__summary">
        Expand from {{ renderInfo().currentReserveTib }} TiB to {{ renderInfo().recommendedReserveTib }} TiB Reserved
    </div>
</div>
